import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import cc from 'classcat';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { TEXT } from '../../config/constants';
import Button from '../Button';
import css from './EmailCaptureLite.module.scss';
import validEmail from '../../utils/strings/validEmail';
import withNewsletter from '../withNewsletter';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var _TEXT$emailCapture = TEXT.emailCapture,
    errorMessages = _TEXT$emailCapture.errors,
    success = _TEXT$emailCapture.success,
    title = _TEXT$emailCapture.title,
    text = _TEXT$emailCapture.text;

var EmailCaptureLiteForm = function EmailCaptureLiteForm(_ref) {
  var submitError = _ref.error,
      fetching = _ref.fetching,
      light = _ref.light,
      email = _ref.email,
      onEmailEnter = _ref.onEmailEnter,
      source = _ref.source,
      submit = _ref.submit,
      utmCampaign = _ref.utmCampaign,
      utmMedium = _ref.utmMedium,
      utmSource = _ref.utmSource;

  var _useState = useState(submitError ? errorMessages.submit : false),
      _useState2 = _slicedToArray(_useState, 2),
      error = _useState2[0],
      setError = _useState2[1];

  var _useState3 = useState('Both'),
      _useState4 = _slicedToArray(_useState3, 2),
      gender = _useState4[0],
      setGender = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      submitted = _useState6[0],
      setSubmitted = _useState6[1];

  var onChangeRadio = function onChangeRadio(event) {
    var value = event.target.value;
    setGender(value);
  };

  var onSubmit = function onSubmit(event) {
    if (event !== undefined) {
      event.preventDefault();
    }

    if (!validEmail(email)) {
      setError(errorMessages.email);
      return false;
    }

    setError(false);
    var body = {
      email: email,
      gender: gender,
      source: source,
      utm_campaign: utmCampaign,
      utm_medium: utmMedium,
      utm_source: utmSource
    };
    window.optimizely = window.optimizely || [];
    window.optimizely.push({
      type: 'event',
      eventName: 'EmailCaptureSubmit'
    });
    submit(body);
    setSubmitted(true);
    return true;
  };

  var rootClass = cc([css.form, _defineProperty({}, css.light, light), _defineProperty({}, css.shake, error)]);
  var contentClass = cc([css.content, css.formContent, _defineProperty({}, css.hide, submitted)]);
  var successClass = cc([css.content, css.success, _defineProperty({}, css.show, submitted)]);
  return /*#__PURE__*/_jsxs("form", {
    "aria-labelledby": "email-capture-title",
    "aria-describedby": "email-capture-desc",
    className: rootClass,
    onSubmit: onSubmit,
    children: [!submitted && /*#__PURE__*/_jsxs("div", {
      className: contentClass,
      children: [/*#__PURE__*/_jsx("h2", {
        className: css.title,
        id: "email-capture-title",
        children: title
      }), /*#__PURE__*/_jsx("p", {
        className: css.text,
        id: "email-capture-desc",
        children: text
      }), /*#__PURE__*/_jsx("div", {
        className: css.labels,
        children: /*#__PURE__*/_jsxs("label", {
          htmlFor: "email",
          children: [/*#__PURE__*/_jsx("div", {
            className: css.label,
            children: "Email"
          }), /*#__PURE__*/_jsx("input", {
            className: css.input,
            id: "email",
            name: "email",
            onChange: onEmailEnter,
            type: "email",
            value: email
          })]
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: css.radios,
        children: [/*#__PURE__*/_jsx("div", {
          className: css.radioLabel,
          children: "Email preference:"
        }), /*#__PURE__*/_jsxs("div", {
          className: css.radiosInner,
          children: [/*#__PURE__*/_jsxs("div", {
            className: css.radiosWrap,
            role: "radiogroup",
            "aria-label": "Email gender preference",
            children: [/*#__PURE__*/_jsxs("label", {
              className: css.radio,
              "aria-label": "Prefer emails with women's products",
              htmlFor: "shopping-preference-for-her",
              children: [/*#__PURE__*/_jsx("input", {
                id: "shopping-preference-for-her",
                name: "shopping-preference",
                onChange: onChangeRadio,
                type: "radio",
                value: "Female"
              }), "Women"]
            }), /*#__PURE__*/_jsxs("label", {
              className: css.radio,
              htmlFor: "shopping-preference-for-him",
              children: [/*#__PURE__*/_jsx("input", {
                "aria-label": "Prefer emails with men's products",
                id: "shopping-preference-for-him",
                name: "shopping-preference",
                onChange: onChangeRadio,
                type: "radio",
                value: "Male"
              }), "Men"]
            }), /*#__PURE__*/_jsxs("label", {
              className: css.radio,
              htmlFor: "shopping-preference-for-both",
              children: [/*#__PURE__*/_jsx("input", {
                "aria-label": "Prefer emails with both women and men's products",
                id: "shopping-preference-for-both",
                name: "shopping-preference",
                onChange: onChangeRadio,
                type: "radio",
                value: "Both"
              }), "Both"]
            })]
          }), /*#__PURE__*/_jsx("footer", {
            className: css.footer,
            children: /*#__PURE__*/_jsxs(Button, {
              "aria-busy": fetching,
              big: true,
              disabled: fetching,
              borderedHover: light,
              type: "submit",
              children: [/*#__PURE__*/_jsx("span", {
                className: css.desktop,
                children: "Sign Up Now"
              }), /*#__PURE__*/_jsx("span", {
                className: css.mobile,
                children: "Sign Up"
              })]
            })
          })]
        })]
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: successClass,
      children: [/*#__PURE__*/_jsx("h2", {
        className: css.title,
        children: success.title
      }), /*#__PURE__*/_jsx("p", {
        className: css.text,
        role: "status",
        children: submitted ? success.text : ''
      })]
    }), error && /*#__PURE__*/_jsx("p", {
      className: css.error,
      role: "status",
      children: error
    })]
  });
};

EmailCaptureLiteForm.defaultProps = {
  light: false,
  utmCampaign: '',
  utmMedium: '',
  utmSource: ''
};
EmailCaptureLiteForm.propTypes = {
  email: PropTypes.string.isRequired,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
  light: PropTypes.bool,
  fetching: PropTypes.bool.isRequired,
  onEmailEnter: PropTypes.func.isRequired,
  source: PropTypes.string.isRequired,
  submit: PropTypes.func.isRequired,
  utmCampaign: PropTypes.string,
  utmMedium: PropTypes.string,
  utmSource: PropTypes.string
};
export default withNewsletter(EmailCaptureLiteForm);